import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/product';
export function Bonuses() {
  return <section className="bg-paper px-4 py-6 sm:py-8" data-id="element-18" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="av35ut3p3515">
        <h2 className="text-center text-2xl text-navy sm:text-4xl" data-id="element-20" data-mp="aua7ogisxnum">
          🎁 5 PROFESSIONAL BONUSES INCLUDED
        </h2>

        <ul className="mt-4 grid gap-2.5 md:grid-cols-2" data-id="element-21" data-mp="fsbnmskxl71v">
          {bonuses.map(bonus => <li key={bonus.num} className="flex flex-col rounded-xl border border-auto/25 bg-white p-4 shadow-sm" data-id="element-22" data-mp="1t3ofzorpyxo">
              <p className="flex items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-wider text-alert" data-id="element-23" data-mp="3o2epo2niut6c">
                <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="3t1835v2t6k6i" />
                Bonus {bonus.num}
              </p>
              <h3 className="mt-1 text-lg text-navy sm:text-xl" data-id="element-25" data-mp="1m85mtp9phwlu">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-xs font-semibold uppercase tracking-wide text-auto" data-id="element-26" data-mp="1r6z0piswnpmj">
                {bonus.subtitle}
              </p>
              <p className="mt-1.5 text-sm font-medium leading-snug text-ink/80" data-id="element-27" data-mp="3deacddp562e0">
                {bonus.body}
              </p>
              <p className="mt-auto pt-2 font-display text-base uppercase tracking-wide text-cyan" data-id="element-28" data-mp="3r5ynbdnnmkte">
                {bonus.kicker}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}